import { render, staticRenderFns } from "./knowledge-weak-point.vue?vue&type=template&id=7ac9336a&scoped=true"
import script from "./knowledge-weak-point.vue?vue&type=script&lang=js"
export * from "./knowledge-weak-point.vue?vue&type=script&lang=js"
import style0 from "./knowledge-weak-point.vue?vue&type=style&index=0&id=7ac9336a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9336a",
  null
  
)

export default component.exports